module.exports = "pegasus_template/assets/frame-linkedin.png";